import * as user from "./user";
import * as list from "./list";
import * as predictiveCall from "./predictiveCall";
const api = {
  user,
  list,
  predictiveCall,
};

export default api;
